// FIXME: This is a manual cache update for the cockpit query.
// We necessarily need to align typing and response modesl in
// 7bridges to avoid anything like this going forward.
import { ApolloCache } from '@apollo/client';
import { Combinator, Operator } from '@procureai/query-builder';
import { filter, prepend } from 'ramda';

import {
  SvbrgChatSessionVariant,
  SvbrgThreadFilterField,
  SvbrgThreadOrderField,
  SvbrgIntakeStatus,
  SvbrgSortDirection,
} from '@/generated/gql/graphql';

import { THREAD_LIST_BY_CATEGORIES_QUERY } from './ThreadList.query.gql';

// These variables are used to fetch the list of threads in the cockpit and required for cache helpers to function correctly
export const queryVariables = {
  filter: {
    combinator: Combinator.AND,
    rules: [
      {
        field: SvbrgThreadFilterField.summary,
        operator: Operator.NOT_EMPTY,
      },
    ],
  },
  order: [{ field: SvbrgThreadOrderField.createdAt, sort: SvbrgSortDirection.desc }],
};

export const addToCockpitListQueryCache = (cache: ApolloCache<object>, id: string, initialMessage?: string) => {
  cache.updateQuery(
    {
      query: THREAD_LIST_BY_CATEGORIES_QUERY,
      variables: queryVariables,
    },
    (data) => {
      const currentNodes = data?.sevenbridges.threadList.nodes;
      const nodes = prepend(
        {
          id,
          summary: initialMessage || '',
          variant: SvbrgChatSessionVariant.CHAT,
          status: SvbrgIntakeStatus.DRAFT,
          createdAt: new Date().toISOString(),
          sequenceNumber: -1, // temporary sequence number only. Not used for sorting in the cockpit
          createdBy: null,
          demandId: null,
          demandSequenceNumber: null,
          demandResponsibleUsers: [],
          __typename: 'SvbrgThreadItem',
        },
        currentNodes ?? [],
      );
      return {
        sevenbridges: {
          threadList: {
            nodes,
            totalCount: nodes.length,
          },
        },
      };
    },
  );
};

export const removeFromCockpitListQueryCache = (cache: ApolloCache<object>, id: string) => {
  cache.updateQuery(
    {
      query: THREAD_LIST_BY_CATEGORIES_QUERY,
      variables: queryVariables,
    },
    (data) => {
      const currentNodes = data?.sevenbridges.threadList.nodes;

      const nodes = filter((item) => item.id !== id, currentNodes ?? []);

      return {
        sevenbridges: {
          threadList: {
            nodes,
            totalCount: nodes.length,
          },
        },
      };
    },
  );
};
